export default __webpack_public_path__ + "static/media/LinkedinSVG.72443041.svg";